module.exports = [
	{
		"value": 1,
		"label": "CallPlus"
	},
	{
		"value": 2,
		"label": "Slingshot"
	},
	{
		"value": 3,
		"label": "Spark (Telecom)"
	},
	{
		"value": 4,
		"label": "Vodafone"
	},
	{
		"value": 5,
		"label": "Orcon"
	},
	{
		"value": 6,
		"label": "Other"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/checkout/CurrentConnection/landlines.json
 ** module id = 482
 ** module chunks = 0
 **/